export function parseAtlasDelimitedRows(text: string, delimiter = ';'): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;

  for (let index = 0; index < text.length; index++) {
    const char = text[index];
    const nextChar = text[index + 1];

    if (char === '"' && inQuotes && nextChar === '"') {
      field += '"';
      index++;
    } else if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === delimiter && !inQuotes) {
      row.push(field);
      field = '';
    } else if ((char === '\n' || char === '\r') && !inQuotes) {
      if (char === '\r' && nextChar === '\n') {
        index++;
      }
      row.push(field);
      if (row.some(value => value.trim())) {
        rows.push(row);
      }
      row = [];
      field = '';
    } else {
      field += char;
    }
  }

  row.push(field);
  if (row.some(value => value.trim())) {
    rows.push(row);
  }

  return rows;
}

export function parseAtlasCsvRows(text: string, minimumColumnCount: number, delimiter = ';'): string[][] {
  return parseAtlasDelimitedRows(text, delimiter)
    .slice(1)
    .map(row => row.map(column => column.trim()))
    .filter(row => row.length >= minimumColumnCount);
}

export function getAtlasCsvCell(row: string[], index: number): string {
  return index >= 0 ? (row[index] || '').trim() : '';
}
